import { BaseToolbarNavPageLayout } from '../../../../backbone/shared/views/baseLayoutViews';
import { Sensor } from '../../../../backbone-unorganized/shared/sensors/models';
import { Gateway } from '../../../../backbone-unorganized/sensors/models';

export const WizardStepPage = BaseToolbarNavPageLayout.extend({
    toolbarnav_center_title: false,
    toolbarnav_show_add_task: false,
    use_transitions: true,
    toolbarnav_title: function () {
        if (this.isSensorModel()) return _t('mobile_sensors_add_sensor');

        return _t('mobile_sensors_add_gateway');
    },
    className: 'device_wizard',
    model: null, // Gateway or Sensor
    stepNumberKey: null, // i.e Step:1
    nextStepNumberKey: null,
    nextStepViewClass: null,
    stepTitleKey: null, // String to contain step title such as Name this sensor.
    type: 'sensor', // String of either 'sensor' or 'gateway' to determine which model to instaniate
    selectedManufacturer: null, // String of either 'monnit' or 'lora' to determine the device manufacturer

    events: {
        'click .next_step': 'displayNextStep'
    },

    templateHelpers: function () {
        return {
            step_number: this._getStepNumber(),
            step_title: this._getStepTitle()
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        this._setupModel();
        this._setNextStepNumber();
    },

    updateNextButtonState: function (isEnabled) {
        if (!isEnabled) {
            this.$el.find('.next_step').addClass('grayed_out');
            return;
        }

        this.$el.find('.next_step').removeClass('grayed_out');
        return;
    },

    isDisabled: function () {
        return false;
    },

    displayNextStep: function () {
        $f.mobile.nav.show(this.nextStepViewClass, {
            model: this.model,
            stepNumberKey: this.nextStepNumberKey
        });
    },

    isSensorModel: function () {
        return this.model instanceof Sensor;
    },

    _getStepNumber: function () {
        return _t(this.stepNumberKey);
    },

    _getStepTitle: function () {
        return _t(this.stepTitleKey);
    },

    _setNextStepNumber: function () {
        const currentStepKey = this.stepNumberKey;

        switch (currentStepKey) {
            case 'mobile_sensors_wizard_step_one':
                this.nextStepNumberKey = 'mobile_sensors_wizard_step_two';
                break;
            case 'mobile_sensors_wizard_step_two':
                this.nextStepNumberKey = 'mobile_sensors_wizard_step_three';
                break;
            case 'mobile_sensors_wizard_step_three':
                this.nextStepNumberKey = 'mobile_sensors_wizard_step_four';
                break;
            case 'mobile_sensors_wizard_step_four':
                this.nextStepNumberKey = 'mobile_sensors_wizard_step_five';
                break;
            case 'mobile_sensors_wizard_step_five':
                this.nextStepNumberKey = 'mobile_sensors_wizard_step_six';
                break;
            default:
                this.nextStepNumberKey = 'mobile_sensors_wizard_step_one';
                break;
        }
    },

    _setupModel: function () {
        var account = $f.mobile.dashboard.get_active_account_or_group();

        if (this.model) {
            return;
        }

        if (this.type !== 'sensor') {
            this.model = new Gateway();
            return;
        }

        this.model = new Sensor({
            account: {
                id: account.id,
                name: account.get('name')
            }
        });
    }
});
